import dashboard from './images/dashboard.png';
import dslogo from './images/dslogo.png';
import loginbackground from './images/loginbackground.jpg';
import plus from './images/plusicon.png';


import c1 from './images/creatives/1.jpeg';
import c2 from './images/creatives/2.jpeg';
import c3 from './images/creatives/3.jpeg';
import c4 from './images/creatives/4.jpeg';
import c5 from './images/creatives/5.jpeg';

import ProjectsIcon from './images/Tabs/project.png';
import UsersIcon from './images/Tabs/user.png';
import BuildersIcon from './images/Tabs/builder.png';
import DashboardIcon from './images/Tabs/dashboard.png';
import NotificationIcon from './images/Tabs/notificationicon.png';
import SettingsIcon from './images/Tabs/settingsicon.png';
import LeadsIcon from './images/Tabs/leads.png';

export const creatives = {
    c1,
    c2,
    c3,
    c4,
    c5,
}

export { dashboard , dslogo , loginbackground, plus };


export const TabsIcons = {
    ProjectsIcon,
    UsersIcon,
    BuildersIcon,
    DashboardIcon,
    NotificationIcon,
    SettingsIcon,
    LeadsIcon,
};